import { Link } from '@/app_components/common/Link';

interface TopSectionProps {
  title: string;
}

export const TopSection = ({ title }: TopSectionProps) => {
  return (
    <header className='flex flex-col items-start gap-5 p-4 self-stretch bg-neutrals-800'>
      <div className='flex items-start self-stretch'>
        {/* Top Details */}
        <div className='flex flex-col @3xl:flex-row flex-grow gap-2 font-graphik-condensed justify-between'>
          <h2 className='uppercase font-semibold typography-body-graphik text-gray-400! m-0!'>Advertisement</h2>
          <div className='flex items-center gap-4'>
            {/* TODO: This needs to have a modal open to give information */}
            <Link href='/'>
              <h2 className='typography-body-graphik hover:underline font-semibold text-white! m-0!'>
                Advertiser Disclosure
              </h2>
            </Link>
            <span className='typography-body-graphik-small text-white! m-0!'>|</span>
            <Link
              href='https://www.bankrate.com/privacy/'
              rel='nofollow noopener noreferrer'
              target='_blank'
              type='white'
            >
              <h2 className='typography-body-graphik hover:underline font-semibold text-white! m-0!'>Privacy Policy</h2>
            </Link>
          </div>
          <Link
            className='@3xl:flex items-center gap-2 self-stretch hidden text-white!'
            href='https://www.bankrate.com/'
            rel='nofollow noopener noreferrer'
            target='_blank'
          >
            <h2 className='typography-body-graphik-xsmall hover:underline font-graphik-compact m-0!'>Powered by</h2>
            <span className='icon w-[60px] icon-bankrate' />
          </Link>
        </div>
      </div>
      <h1 className='typography-heading-graphik-condensed-level-2 text-white! font-graphik-condensed m-0!'>{title}</h1>
    </header>
  );
};
